import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

export const AreaA_Hatchback_Center: React.FC<AreaSVGProps> = ({
  fill = '#148B4D',
  stroke = '#148B4D',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="239"
      height="175"
      viewBox="0 0 239 175"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_a_hatchback_center"
          x="0"
          y="0"
          width="239"
          height="175"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
      <g filter="url(#filter_area_a_hatchback_center)">
        <path
          d="M48.0469 10.8887C63.5407 5.38926 97.096 -0.267279 119.381 0.00978168L119.431 0.0107582L119.48 0.00978168C141.767 -0.267216 175.274 5.39008 190.766 10.8897C201.549 23.8335 210.928 45.2116 218.975 73.4736C226.924 101.396 233.459 135.609 238.856 174.129C238.833 174.135 238.81 174.142 238.787 174.147C237.982 174.345 237.119 174.537 236.285 174.705C233.463 171.645 229.032 168.646 223.696 165.846C216.937 162.298 208.139 158.771 197.772 155.669C177.046 149.467 149.771 144.884 119.43 145.347C89.0904 144.884 61.8151 149.466 41.0869 155.666C30.7195 158.767 21.9206 162.294 15.1602 165.841C9.82268 168.641 5.38915 171.639 2.56641 174.699C1.73267 174.531 0.870535 174.341 0.0664062 174.144C0.0442045 174.138 0.0220466 174.131 0 174.126C5.39495 135.606 11.92 101.395 19.8594 73.4727C27.8957 45.2099 37.2641 23.8318 48.0469 10.8887Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
